import React from 'react';
import { Col } from 'reactstrap';
import { UsurpAd } from 'site-modules/shared/components/native-ad/srp-ad/usurp-ad';
import { EasListingUsurpAdAsFallBack } from 'site-modules/shared/components/native-ad/eas-listing-usurp-ad/eas-listing-usurp-ad';
import { ExcoVideoWrapperAsync } from 'site-modules/shared/components/exco-video/exco-video-wrapper-async';
import { UsurpMyWidget } from 'site-modules/shared/components/native-ad/srp-ad/usurp-my-widget';

// MINIMUM_CARDS and first position values should be equals (ADS-5322)
export const MINIMUM_CARDS = 4;

export const UsurpAdsConfig = {
  [MINIMUM_CARDS]: {
    component(AdTargetingPrefetch, adProps) {
      return (
        <AdTargetingPrefetch key="srp-retention-4">
          <UsurpAd dco {...adProps} useEasListingFallback />
        </AdTargetingPrefetch>
      );
    },
  },
  8: {
    component(AdTargetingPrefetch, adProps) {
      return (
        <AdTargetingPrefetch key="srp-retention-7">
          <UsurpAd position={'2'} {...adProps} useEasListingFallback />
        </AdTargetingPrefetch>
      );
    },
  },
  12: {
    component(AdTargetingPrefetch, adProps) {
      return (
        <AdTargetingPrefetch key="srp-retention-11">
          <UsurpAd position={'3'} {...adProps} useEasListingFallback />
        </AdTargetingPrefetch>
      );
    },
  },
  16: {
    component(AdTargetingPrefetch, adProps) {
      return (
        <AdTargetingPrefetch key="srp-retention-15">
          <UsurpMyWidget position={'4'} {...adProps} useEasListingFallback />
        </AdTargetingPrefetch>
      );
    },
  },
  default: {
    component(AdTargetingPrefetch, adProps) {
      return (
        <AdTargetingPrefetch key="srp-retention-7-default">
          <UsurpAd {...adProps} useEasListingFallback />
        </AdTargetingPrefetch>
      );
    },
  },
  last: {
    component(AdTargetingPrefetch, adProps) {
      return (
        <AdTargetingPrefetch key="eas-listing-usurp-ad">
          <EasListingUsurpAdAsFallBack {...adProps} />
        </AdTargetingPrefetch>
      );
    },
  },
  exco: {
    component() {
      return (
        <Col key="exco" tag="li" xs={12} className="mb-0_75 mb-md-1_5 d-inline-block">
          <div
            style={{ aspectRatio: '16 / 9', maxWidth: '550px' }}
            className="rounded-12 overflow-hidden mx-auto usurp-inventory-card"
          >
            <ExcoVideoWrapperAsync showTestText={false} />
          </div>
        </Col>
      );
    },
  },
};
